// v2 COLLAB-13689
export const WMC_MARKETS = [
  'link.zalando.de',
  'zalando.de',
  'en.zalando.de',
  'zalando.fr',
  'fr.zalando.be',
  'zalando.be',
  'zalando.at',
  'zalando.it',
  'zalando.no',
  'zalando.ch',
  'fr.zalando.ch',
  'it.zalando.ch',
  'zalando.es',
  'zalando.se',
  'zalando.co.uk',
  'zalando.nl',
  'zalando.dk',
  'zalando.pl',
  'zalando.fi',
  'zalando.cz',
  'zalando.ie',
  'zalando.sk',
  'zalando.sl',
  'zalando.lt',
  'zalando.ee',
  'zalando.lv',
  'zalando.hr'
];

// TODO: v1 delete below after v2 is fully implemented
export const LANGUAGE_DATA = {
  'austria': ['german'],
  'belgium': ['french', 'dutch'],
  'czech republic': ['czech'],
  'denmark': ['danish'],
  'finland': ['finnish'],
  'france': ['french'],
  'germany': ['german', 'english'],
  'ireland': ['english'],
  'italy': ['italian'],
  'netherlands': ['dutch'],
  'norway': ['norwegian'],
  'poland': ['polish'],
  'spain': ['spanish'],
  'sweden': ['swedish'],
  'switzerland': ['german', 'french', 'italian'],
  'united kingdom': ['english']
};

export const DEFAULT_COUNTRY = 'germany';
// END TODO: v1 delete above after v2 is fully implemented
